const sideWidth = 100;

const styles = {
    root: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'row',
    },
    left: {
        width: sideWidth + 'px',
    },
    center: {
        height: '100%',
        width: `calc(100% - ${sideWidth * 2}px)`,
        backgroundColorcolor: 'orange',
        display: 'flex',
        flexDirection: 'column',
        // fontStyle: 'italic',
        // margin: 0,
    },
    rigth: {
        width: sideWidth + 'px',
    },
    heading: {
        margin: 0,
    },
    tabs: {
        root: {
            width: '100%',
        },
    },
};

export default styles;
